import type { PrivacyModuleConfig } from '../../types/modules/privacy';

export const DEFAULT_PRIVACY_MODULE_CONFIG: PrivacyModuleConfig = {
  enabled: false,

  consent: {
    enabled: false,
    required: false,
  },

  pii: {
    enabled: false,
    hashEmail: true,
    hashPhone: true,
  },

  anonymization: {
    enabled: false,
    anonymizeIp: true,
  },
};
